import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';
import type { PackagingOption } from '../../graphql/query/getDelivery';

type PackagingOptionContextType = {
  packagingOption: PackagingOption;
  setPackagingOption: (option: PackagingOption) => void;
};

const PackagingOptionContext = createContext<
  PackagingOptionContextType | undefined
>(undefined);

export const PackagingOptionProvider = ({
  children,
  initialPackagingOption,
}: {
  children: ReactNode;
  initialPackagingOption?: PackagingOption | null;
}) => {
  const [packagingOption, setPackagingOption] = useState<PackagingOption>(
    initialPackagingOption ?? 'NONE',
  );

  return (
    <PackagingOptionContext.Provider
      value={{ packagingOption, setPackagingOption }}
    >
      {children}
    </PackagingOptionContext.Provider>
  );
};

export const usePackagingOption = () => {
  const context = useContext(PackagingOptionContext);
  if (context === undefined) {
    throw new Error(
      'usePackagingOption must be used within a PackagingOptionProvider',
    );
  }
  return context;
};
